import classNames from 'classnames';
import styles from './OfficeCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';

export interface UI_OfficeProps {
	className?: string;
	heading?: string;
	address?: string;
	zipcode?: string;
}

export const UI_OfficeCard: React.FC<UI_OfficeProps> = ({ className, heading, address, zipcode }) => (
	<div className={classNames(styles.OfficeCard, className)}>
		<div className={styles.OfficeCard_textbox}>
			{heading && (
				<UI_Heading headingLevel="h3" className={styles.OfficeCard_heading}>
					{heading}
				</UI_Heading>
			)}
			<div className={styles.OfficeCard_text}>
				{address && <UI_Paragraph>{address}</UI_Paragraph>}
				{zipcode && <UI_Paragraph>{zipcode}</UI_Paragraph>}
			</div>
		</div>
	</div>
);
